module.exports = __webpack_public_path__ + "img/CheckMark_small.aec30bc7.svg";